import React, { useState } from "react";
import styles from './OwnFormAgreement.module.scss';
import Card, { CardItem } from "../../../../../components/card/Card";
import Button from "../../../../../components/ripple/Button";
import { useRouter } from "next/router";
import DraftHTML from "../../../../../components/draftEditor/export/DraftHTML";
import { NAV_STACK_LIST } from "../../../../../settings/navigation";

function OwnFormAgreement({agreement, custom, onRefuse, onAgree}) {

    const router = useRouter();
    const [locked, setLocked] = useState(false);
    const [button, setButton] = useState(undefined);

    return (
        <Card title={`We need your consent`} className={styles.layout}>
            <div className={styles.content}>
                <DraftHTML
                    className={`content-editor ${styles.content__container}`}
                    content={agreement}
                />
            </div>
            <CardItem className={styles.bottom}>
                <p className={styles.bottom__message}>
                    By using the Own server connector, you acknowledge that you have read, understood, and agree to be
                    bound by this User Agreement.
                </p>
                <div className={styles.bottom__buttons}>
                    <Button
                        title='REFUSE'
                        displayType='text'
                        onClick={() => {
                            setLocked(true);
                            setButton(1);
                            if (custom) {
                                onRefuse();
                            } else {
                                router.replace(`${NAV_STACK_LIST}/${router.query.stack}`)
                            }
                        }}
                        disabled={locked}
                        iconRight={locked && button === 1 ? `fas fa-spinner fa-spin` : undefined}
                    />
                    <Button
                        title='AGREE'
                        onClick={() => {
                            onAgree();
                            setLocked(true);
                            setButton(2);
                        }}
                        disabled={locked}
                        iconRight={locked && button === 2 ? `fas fa-spinner fa-spin` : undefined}
                    />
                </div>
            </CardItem>
        </Card>
    )
}

export default OwnFormAgreement